module.exports = __webpack_public_path__ + "img/2.dfece262.png";